import React from "react";
import {
	FileGroup,
	InputField,
	SelectField,
	SelectFieldStatus,
} from "../../../components/Form/FormComponents";
import { getFormattedDate } from "../../../utils/DateUtils";
import { businessTypes, calculateProgramSavings, getUserName } from "../utils";
import { getRequestValue } from "../../../utils/Utils";
import { DurationOptions } from "../../../Constants";

/* eslint-disable react/prop-types */
export const FundsInformFields = ({ formData, isEditable, handleInputChange, except }) => {
	const investorName =
		formData?.requestType === "old"
			? formData?.investorFinanceInfo?.name
			: formData?.investorsInfo?.length
			? formData?.investorsInfo[0]?.investorName
			: "---";

	const programSavings = calculateProgramSavings(formData?.totalAmountRepayable, formData?.tenure);

	return (
		<>
			<div className='form-group'>
				<label>DATE / TIME</label>
				<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
			</div>

			<div className='form-group'>
				<label>TRN ID</label>
				<InputField name='trnId' value={"TRN-" + formData?.objectId} />
			</div>

			<div className='form-group'>
				<label>BUSINESS INTEREST</label>
				<InputField name='businessInterest' handleChange={handleInputChange} value={formData?.businessType} />
			</div>

			{formData?.requestStatus !== "ongoing" && (
				<div className='form-group'>
					<label>INVESTOR</label>
					<InputField name='investor' value={investorName} />
				</div>
			)}

			<div className='form-group'>
				<label>APPRENTICE</label>
				<InputField name='apprentice' value={getUserName(formData)} />
			</div>

			<div className='form-group'>
				<label>A.F TYPE</label>
				<SelectField
					name='type'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.type}
					options={["Quick", "Sponsored"]}
				/>
			</div>

			<div className='form-group'>
				<label>AMOUNT TO RAISE</label>
				<InputField
					name='amountToRaise'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.amount}
				/>
			</div>

			<div className='form-group'>
				<label>EXPECTED PROFIT</label>
				<InputField
					name='expectedProfit'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.expectedProfit}
				/>
			</div>

			<div className='form-group'>
				<label>A.F DURATION</label>
				<InputField
					name='duration'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.tenure}
				/>
			</div>

			<div className='form-group'>
				<label>PAYMENT TYPE</label>
				<SelectField
					name='paymentType'
					handleChange={handleInputChange}
					value={formData?.paymentType}
					isEditable={isEditable}
					options={["wallet", "bank", "card"]}
				/>
			</div>

			<div className='form-group'>
				<label>INTEREST RATE</label>
				<InputField
					name='interestRate'
					isEditable={isEditable}
					handleChange={handleInputChange}
					value={formData?.interestRate}
				/>
			</div>

			<div className='form-group'>
				<label>PROGRAM SAVINGS</label>
				<InputField
					// name='programSavings'
					isEditable={isEditable}
					handleChange={handleInputChange}
					value={`₦${programSavings || formData?.programSavings}`}
				/>
			</div>

			<div className='form-group'>
				<label>BUSINESS TYPE</label>
				<InputField
					name='businessType'
					isEditable={isEditable}
					handleChange={handleInputChange}
					value={formData?.businessType}
				/>
			</div>

			<div className='form-group'>
				<label>BUSINESS DESCRIPTION</label>
				<InputField
					name='businessDescription'
					isEditable={isEditable}
					handleChange={handleInputChange}
					value={formData?.businessDescription}
				/>
			</div>

			<div className='form-group'>
				<label>PURPOSE</label>
				<InputField
					name='purpose'
					isEditable={isEditable}
					handleChange={handleInputChange}
					value={formData?.purpose}
				/>
			</div>

			{!except?.includes("approvalStatus") && (
				<div className='form-group'>
					<label>APPROVAL</label>
					<SelectFieldStatus
						name='approvalStatus'
						isEditable={isEditable}
						handleChange={handleInputChange}
						value={formData?.approvalStatus}
						type={formData?.approvalStatus?.toLowerCase()}
						options={["settled", "pending", "default"]}
					/>
				</div>
			)}

			{!except?.includes("disbursement") && (
				<div className='form-group'>
					<label>DISBURSEMENT</label>
					<SelectFieldStatus
						name='disbursement'
						handleChange={handleInputChange}
						isEditable={isEditable}
						value={formData?.disbursement}
						type={formData?.disbursement?.toLowerCase()}
						options={["pending", "approved", "default"]}
					/>
				</div>
			)}

			<div className='form-group'>
				<label>REQUEST</label>
				<InputField name='request' handleChange={handleInputChange} value={getRequestValue(formData)} />
			</div>
		</>
	);
};

// Submitted Application
export const FundsInformFieldsSubmitted = ({ formData, isEditable, handleInputChange }) => {
	return (
		<>
			<div className='form-group'>
				<label>DATE / TIME</label>
				<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
			</div>

			<div className='form-group'>
				<label>BUSINESS INTEREST</label>
				<InputField
					name='businessInterest'
					handleChange={handleInputChange}
					value={formData?.businessInterest}
				/>
			</div>

			<div className='form-group'>
				<label>A.F TYPE</label>
				<SelectField
					name='type'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.type}
					options={["Quick", "Sponsored"]}
				/>
			</div>

			<div className='form-group'>
				<label>APPRENTICE</label>
				<InputField name='apprentice' value={formData?.apprentice || getUserName(formData)} />
			</div>

			<div className='form-group'>
				<label>AMOUNT TO RAISE</label>
				<InputField
					name='amountToRaise'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.amountToRaise}
				/>
			</div>

			<div className='form-group'>
				<label>EXPECTED PROFIT</label>
				<InputField
					name='expectedProfit'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.expectedProfit}
				/>
			</div>

			<div className='form-group'>
				<label>MODEL</label>
				<InputField
					name='model'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.model}
				/>
			</div>

			<div className='form-group'>
				<label>YEAR</label>
				<InputField
					name='year'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.year}
				/>
			</div>

			<div className='form-group'>
				<label>CONDITION</label>
				<InputField
					name='condition'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.condition}
				/>
			</div>

			<div className='form-group'>
				<label>COLOR</label>
				<InputField
					name='color'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.color}
				/>
			</div>

			<div className='form-group'>
				<label>DELIVERY FEE</label>
				<InputField
					name='delivery_fee'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.delivery_fee}
				/>
			</div>

			<div className='form-group'>
				<label>TRN ID</label>
				<InputField name='trnId' value={"TRN-" + formData?.objectId} />
			</div>

			<div className='form-group'>
				<label>APPROVAL</label>
				<SelectFieldStatus
					name='approvalStatus'
					isEditable={isEditable}
					handleChange={handleInputChange}
					value={formData?.approvalStatus}
					type={formData?.approvalStatus?.toLowerCase()}
					options={["settled", "pending", "default"]}
				/>
			</div>

			<div className='form-group'>
				<label>REQUEST</label>
				<InputField
					name='request'
					handleChange={handleInputChange}
					// isEditable={isEditable}
					value={getRequestValue(formData)}
				/>
			</div>
		</>
	);
};

// Create Asset
export const FundsInformFieldsAsset = ({ formData, isEditable, handleInputChange }) => {
	return (
		<>
			<div className='form-group'>
				<label>DATE / TIME</label>
				<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
			</div>

			<div className='form-group'>
				<label>TRX ID</label>
				<InputField name='objectId' value={`TRN-${formData?.objectId}`} />
			</div>

			<div className='form-group'>
				<label>INVESTOR</label>
				<InputField name='investor' value={formData?.investorInfo?.name} />
			</div>

			<div className='form-group'>
				<label>A.F TYPE</label>
				<SelectField
					name='type'
					handleChange={handleInputChange}
					// isEditable={isEditable}
					value={formData?.type}
					options={["Quick", "Sponsored"]}
				/>
			</div>

			<div className='form-group'>
				<label>INTEREST RATE</label>
				<InputField
					name='interestRate'
					// isEditable={isEditable}
					handleChange={handleInputChange}
					value={formData?.interestRate}
				/>
			</div>

			<div className='form-group'>
				<label>BUSINESS INTEREST</label>
				<SelectField
					name='businessType'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.businessType}
					options={businessTypes?.map((a) => a?.label)}
				/>
			</div>

			<div className='form-group'>
				<label>AMOUNT TO INVEST</label>
				<InputField
					name='amountToInvest'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.amountToInvest}
				/>
			</div>

			<div className='form-group'>
				<label>EXPECTED PROFIT</label>
				<InputField
					name='amountToRepay'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.amountToRepay}
				/>
			</div>

			<div className='form-group'>
				<label>WAITING PERIOD</label>
				<SelectField
					name='waitingPeriod'
					handleChange={handleInputChange}
					value={formData?.waitingPeriod}
					isEditable={isEditable}
					options={DurationOptions}
				/>
			</div>

			<div className='form-group'>
				<label>A.F DURATION</label>
				<SelectField
					name='duration'
					handleChange={handleInputChange}
					value={formData?.duration}
					isEditable={isEditable}
					options={DurationOptions}
				/>
			</div>

			<div className='form-group'>
				<label>REQUEST STATUS</label>
				<p style={{ textTransform: "capitalize", fontWeight: "600" }}>{formData?.status}</p>
			</div>
		</>
	);
};

export const IdentificationGroup = ({ formData }) => {
	return (
		<>
			<div className='form-group'>
				<label>Type</label>
				<InputField name='idType' value={formData?.user?.investorProfile?.idType} />
			</div>

			<div className='form-group'>
				<label>NUMBER</label>
				<InputField name='idNumber' value={formData?.user?.investorProfile?.idNumber} />
			</div>

			<div className='form-group'>
				<label>EXPIRY DATE</label>
				<InputField name='idExpiryDate' value={formData?.user?.investorProfile?.idExpiryDate} />
			</div>

			<div className='form-group'>
				<FileGroup name='bank_statement_g1' value={formData?.user?.idCard} />
			</div>
		</>
	);
};

// Savings
export const SavingsInformFields = ({ formData }) => {
	return (
		<>
			<div className='form-group'>
				<label>DATE / TIME</label>
				<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
			</div>

			<div className='form-group'>
				<label>SAVINGS TYPE</label>
				<InputField name='savingsType' value={formData?.savingsType} />
			</div>

			<div className='form-group'>
				<label>ASSET NAME</label>
				<InputField name='productName' value={formData?.productName} />
			</div>

			<div className='form-group'>
				<label>FREQUENCY</label>
				<InputField name='frequency' value={formData?.frequency} />
			</div>

			<div className='form-group'>
				<label>DAY OF MONTH</label>
				<InputField name='dayOfTheMonth' value={formData?.dayOfTheMonth} />
			</div>

			<div className='form-group'>
				<label>TENOR</label>
				<InputField name='tenure' value={formData?.tenure} />
			</div>

			<div className='form-group'>
				<label>AMOUNT</label>
				<InputField name='amountToSave' value={formData?.amountToSave} />
			</div>

			<div className='form-group'>
				<label>INTEREST</label>
				<InputField name='interest' value={formData?.interestRate} />
			</div>

			<div className='form-group'>
				<label>AUTOMATION</label>
				<InputField name='automation' value={formData?.automation} />
			</div>

			<div className='form-group'>
				<label>PAYMENT MODE</label>
				<InputField name='paymentMode' value={formData?.paymentMode} />
			</div>

			<div className='form-group'>
				<label>WITHDRAWAL REQUEST</label>
				<InputField name='withdrawal_request' value={formData?.maturityDate} />
			</div>

			<div className='form-group'>
				<label>APPROVAL</label>
				<SelectFieldStatus
					name='approvalStatus'
					value={formData?.approvalStatus}
					type={formData?.approvalStatus?.toLowerCase()}
					options={["settled", "pending", "default"]}
				/>
			</div>

			{/* <div className='form-group'>
				<label>HISTORY</label>
				<a href='#' style={{ textDecoration: "underline" }}>
					View History
				</a>
			</div> */}
		</>
	);
};

// General
export const AttachmentsGroup = ({ formData }) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>UPLOADED DOCUMENT</label>
				<FileGroup name='financialDocument' value={formData?.attachmentDoc?.url} />
			</div>

			{/* <div className='form-group'>
				<label>BUSINESS PLAN</label>
				<FileGroup name='businessPlan' value={formData?.attachmentFile?.businessPlan} />
			</div> */}

			<div className='form-group'>
				<label>CERTIFICATE OF INCORPORATION</label>
				<FileGroup
					name='certificateOfIncorporation'
					value={formData?.investorId?.certificateOfIncorporation}
				/>
			</div>
		</div>
	);
};

export const ApprenticeInformation = ({ formData, handleInputChange }) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>Name</label>
				<InputField name='apprentice' handleChange={handleInputChange} value={getUserName(formData)} />
			</div>

			<div className='form-group'>
				<label>HOME ADDRESS</label>
				<InputField
					name='delivery_address'
					handleChange={handleInputChange}
					value={formData?.user?.homeAddress}
				/>
			</div>

			<div className='form-group'>
				<label>PHONE NUMBER</label>
				<InputField name='phone_number' handleChange={handleInputChange} value={formData?.user?.phone} />
			</div>
		</div>
	);
};

export const InvestorInformation = ({ formData }) => {
	console.log(formData);
	const investorInfo =
		formData?.requestType === "old"
			? formData?.investorFinanceInfo
			: formData?.requestType === "admin-creates" || formData?.requestType === "investor-creates"
			? formData?.investorInfo
			: formData?.investorsInfo
			? formData?.investorsInfo[0]
			: null;

	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>Name</label>
				<InputField name='investor' value={investorInfo?.name || investorInfo?.investorName} />
			</div>

			<div className='form-group'>
				<label>ADDRESS</label>
				<InputField name='delivery_address' value={investorInfo?.address || investorInfo?.investorAddress} />
			</div>

			<div className='form-group'>
				<label>PHONE NUMBER</label>
				<InputField name='phone_number' value={investorInfo?.phone || investorInfo?.investorPhone} />
			</div>
		</div>
	);
};

export const Guarantor_1 = ({ formData }) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>NAME</label>
				<InputField name='guarantor_name1' value={formData?.guarantor?.name1} />
			</div>

			<div className='form-group'>
				<label>PHONE</label>
				<InputField name='guarantor_phone1' value={formData?.guarantor?.phone1} />
			</div>

			<div className='form-group'>
				<label>EMAIL</label>
				<InputField name='guarantor_phone1' value={formData?.guarantor?.email1} />
			</div>
		</div>
	);
};

export const Guarantor_2 = ({ formData }) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>NAME</label>
				<InputField name='guarantor_2_name' value={formData?.guarantor?.name2} />
			</div>

			<div className='form-group'>
				<label>PHONE</label>
				<InputField name='guarantor_2_phone' value={formData?.guarantor?.phone2} />
			</div>

			<div className='form-group'>
				<label>EMAIL</label>
				<InputField name='guarantor_2_email' value={formData?.guarantor?.email2} />
			</div>
		</div>
	);
};

export const NegotiatorsGroup = ({ formData }) => {
	return (
		<div className='grid grid-cols-4 gap-3'>
			<div className='form-group'>
				<label>NEGOTIATOR</label>
				<InputField name='negotiator_name' value={formData?.negotiator_name} />
			</div>

			<div className='grid'>
				<div className='form-group'>
					<label>LEASE TERM</label>
					<InputField name='negotiator_lease_term' value={formData?.negotiator_lease_term} />
				</div>

				<div className='form-group'>
					<label>INTEREST RATE</label>
					<InputField name='negotiator_lease_term' value={formData?.negotiator_lease_term} />
				</div>

				<div className='form-group'>
					<label>LEASE STRUCTURE</label>
					<InputField name='negotiator_lease_term' value={formData?.negotiator_lease_term} />
				</div>
			</div>

			<div className='grid'>
				<div className='form-group'>
					<label>PROPOSAL</label>
					<InputField name='negotiator_proposal' value={formData?.negotiator_proposal} />
				</div>

				<div className='form-group'>
					<label>PROPOSAL</label>
					<InputField name='negotiator_proposal' value={formData?.negotiator_proposal} />
				</div>

				<div className='form-group'>
					<label>PROPOSAL</label>
					<InputField name='negotiator_proposal' value={formData?.negotiator_proposal} />
				</div>
			</div>

			<div className='form-group'>
				<label>STATUS</label>
				<InputField name='negotiator_status' value={formData?.negotiator_status} />
			</div>
		</div>
	);
};
